export function getElement(selector: string): Element | null {
	return document.querySelector(selector);
}

export function getDimension(element: Element | null): { height: number } {
	return element ? element.getBoundingClientRect() : { height: 0 };
}

export function getProperty(prop: string) {
	return (object: Record<string, unknown> | null | undefined) => object?.[prop];
}

export function sum(first: number) {
	return (second: number) => {
		return first + second;
	};
}

type TComposableFn = (arg: never) => unknown;

export function compose(...fns: TComposableFn[]): (input: unknown) => unknown {
	return (input: unknown) =>
		[...fns].reverse().reduce((result: unknown, fn) => fn(result as never), input);
}
